import { render, staticRenderFns } from "./EditRecipient.vue?vue&type=template&id=a171411a"
import script from "./EditRecipient.vue?vue&type=script&lang=js"
export * from "./EditRecipient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports